@if (leftMenu$ | async; as leftMenu) {
  <div class="container">
    <div class="left-menu" [ngClass]="{ collapsed: !leftMenu.shown, animated: leftMenu.animated }">
      <alg-left-panel></alg-left-panel>
    </div>
    <ng-container *ngrxLet="{ fullFrameContentDisplayed: fullFrameContentDisplayed$, withLeftPaddingContentDisplayed: withLeftPaddingContentDisplayed$ } as layout">
      <ng-container *ngrxLet="isObserving$ as isObserving">
        <div class="right-container" [ngClass]="{ collapsed: !leftMenu.shown, animated: leftMenu.animated, 'thread-collapsed': !(isDiscussionVisible$ | async) || (isThreadInline$ | async) }">
          <alg-top-bar
            [showBreadcrumbs]="!scrolled && !layout.fullFrameContentDisplayed && !(isNarrowScreen$ | async) && !!(canShowBreadcrumbs$ | async)"
            [modeBarDisplayed]="isObserving"
            [showLeftMenuOpener]="!!(canShowLeftMenu$ | async) && !leftMenu.shown"
            [showTopRightControls]="!!(showTopRightControls$ | async) && !(isNarrowScreen$ | async)"
          ></alg-top-bar>
          <div
            id="main-content-wrapper"
            data-testid="main-content-wrapper"
            class="main-content-wrapper alg-flex-1"
            [class.with-inline-thread]="isThreadInline$ | async"
            algHtmlElLoaded
            (elLoaded)="onLoaded($event)"
            cdkScrollable
          >
            <div
              class="main-content"
              [ngClass]="{ 'with-left-padding': layout.withLeftPaddingContentDisplayed, 'full-frame': layout.fullFrameContentDisplayed }"
              id="main-container"
            >
              <div class="main-content-bottom-padding alg-flex-1">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div
      class="right-thread"
      [ngClass]="{ 'collapsed': !(isDiscussionVisible$ | async), 'inline-mode': isThreadInline$ | async }"
    >
      <alg-thread-container></alg-thread-container>
    </div>
  </div>
}
<alg-toast-messages></alg-toast-messages>
<alg-language-mismatch></alg-language-mismatch>
